import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { eventsSchema } from './schema';
import View from './View';
import './events.css';

const Edit = (props) => {
  const { data = {}, block, onChangeBlock, selected, id } = props;
  const schema = eventsSchema();

  // Support both signatures to be safe
  const onChangeFormData = (...args) => {
    const next =
      args.length === 2 && typeof args[0] === 'string'
        ? { ...data, [args[0]]: args[1] }
        : args[0] || {};
    onChangeBlock(block, next);
  };
  const onChangeField = (field, value) =>
    onChangeBlock(block, { ...data, [field]: value });

  return (
    <>
      <View data={data} id={id} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          onChangeFormData={onChangeFormData}
          onChangeField={onChangeField}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
